import apinode from '../../apinode'

class HistoricoSaldoService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getByIDCliente(idCliente) {
    const response = await apinode.get(
      `/historico-saldo/${idCliente}/${this.idconta}`,
    )

    return response.data
  }
}

export default new HistoricoSaldoService()
